import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const defaultPaginationDetails = {
  currentPage: 0,
  totalPages: 0,
  pageSize: 0,
  totalData: 0,
};

export default {
  namespaced: true,
  state: {
    exp: localStorage.getItem("exp"),
    access_token: localStorage.getItem("access_token"),
    currentLoggedInInfo: {},
    currentUserPermissions: {},
    myUserInfo: {},
    userRolesAndPermission: [],
    userLicenses: {
      data: [],
      paginationDetails: defaultPaginationDetails,
    },
    defaultPaginationDetails,
  },
  getters,
  mutations,
  actions,
};
